import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#00A8E3",
    marginBottom: 24,
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
    fontSize: 12,
    color: "#0A1A53",
  },
  subItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
    marginLeft: 24,
    fontSize: 10,
    color: "#0A1A53",
  },
  itemNumber: {
    width: 24,
    marginRight: 8,
    fontWeight: 600,
  },
  itemLabel: {
    flex: 1,
  },
  itemDots: {
    flex: 1,
    marginLeft: 4,
    marginRight: 4,
    fontSize: 10,
    color: "#999",
  },
  itemPageNumber: {
    flexShrink: 0,
    marginLeft: 8,
  },
});

export const AnalysisReportSommaireSection = () => {
  const { t } = useTranslation();

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <View style={{ width: "80%" }}>
        <Text style={styles.sectionTitle}>{t("pdf.validatedFolders.sections.sommaire.title")}</Text>

        <View style={styles.item}>
          <Text style={styles.itemLabel}>
            {t("pdf.validatedFolders.sections.sommaire.repartionNiveauVigilance")}
          </Text>
        </View>
        <View style={styles.item}>
          <Text style={styles.itemLabel}>
            {t("pdf.validatedFolders.sections.sommaire.repartitionVigilanceRenforcee")}
          </Text>
        </View>
        <View style={styles.item}>
          <Text style={styles.itemLabel}>
            {t("pdf.validatedFolders.sections.sommaire.repartitionDossiersModules")}
          </Text>
        </View>
        <View style={styles.item}>
          <Text style={styles.itemLabel}>
            {t("pdf.validatedFolders.sections.sommaire.syntheseTraitement")}
          </Text>
        </View>
        <View style={styles.subItem}>
          <Text style={styles.itemLabel}>
            {t("pdf.validatedFolders.sections.sommaire.repartitionStatutTraitement")}
          </Text>
        </View>
        <View style={styles.subItem}>
          <Text style={styles.itemLabel}>
            {t("pdf.validatedFolders.sections.sommaire.listeDossiers")}
          </Text>
        </View>
      </View>
    </View>
  );
};
